import {
	GetRequest,
	UpdateRequest,
	DeleteRequest,
} from "../../../../services/requestHelpers";
import { HttpMethods } from "../../../../utils/constants";
import { DisplayMessage } from "../../../../services/helpers";

const getBaseUrl = (module) => {
	const moduleUrls = {
		messageTemplates: "/api/mobopro/v1/messagetemplates/media",
		signableDocuments: "/api/mobopro/v1/signabledocuments/media",
	};

	return moduleUrls[module];
};

export const getMediaFiles = async (module) => {
	try {
		const url = getBaseUrl(module);
		const response = await GetRequest(url);

		if (!response.ok) {
			const errorData = await response.json();
			if (errorData?.errors) {
				errorData.errors.forEach((error) => DisplayMessage(error, "error"));
			} else {
				DisplayMessage("Failed to fetch media files", "error");
			}
			return [];
		}

		const data = await response.json();
		return data || [];
	} catch (error) {
		DisplayMessage(`Error fetching media files: ${error.message}`, "error");
		return [];
	}
};

export const uploadMediaFiles = async (module, files) => {
	try {
		const url = getBaseUrl(module);

		const requestData = JSON.stringify(
			files.map((file) => ({
				file: {
					blobRelativePath: file.blobRelativePath,
					type: file.type,
				},
			}))
		);

		const response = await UpdateRequest(url, requestData, HttpMethods.Post);

		if (!response.ok) {
			const errorData = await response.json();
			if (errorData?.errors) {
				errorData.errors.forEach((error) => DisplayMessage(error, "error"));
			} else {
				DisplayMessage("Failed to upload media files", "error");
			}
			return { success: false };
		}

		return { success: true };
	} catch (error) {
		DisplayMessage(`Error uploading media files: ${error.message}`, "error");
		return { success: false, error: error.message };
	}
};

export const deleteMediaFile = async (mediaFileId, entityType) => {
	try {
		const url = `/api/mobopro/v2/mediafiles?mediafileid=${mediaFileId}&entitytype=${entityType}`;
		return await DeleteRequest(url);
	} catch (error) {
		return { ok: false, error: error.message };
	}
};
